'use client';

import Categories from '@/components/Categories';
import Partners from '@/components/Partners';
import { PartnerSlider } from '@/components/sliders/PartnerSlider';
import { useProductStore } from '@/presentation/hooks/useStores';
import { useEffect } from 'react';
import { ProductsList } from '@/components/ProductsList';
import { observer } from 'mobx-react-lite'; // export async function generateMetadata(props: { params: { locale: string } }) {
// export async function generateMetadata(props: { params: { locale: string } }) {
//   return {
//     title: '',
//     description: '',
//   };
// }

// function Cta() {
//     return <article
//         className="relative m-5 flex h-[480px] justify-center rounded-3xl bg-[#A08DD9] p-4  max-sm:items-end sm:m-8 sm:items-center sm:justify-start sm:p-6  md:h-[470px] md:p-8 lg:p-16 ">
//         <div className="flex flex-col gap-4 sm:gap-10 md:gap-14 lg:gap-24 xl:gap-28">
//             <h1 className="font-garnettSemiBold text-xl text-white sm:text-2xl md:text-3xl lg:text-4xl xl:text-5xl">
//                 Download App for a <br/> Fuss-free financing & <br/> shopping{" "}
//             </h1>
//             <span className="grid  h-fit w-[230px] grid-cols-2 gap-2">
//             <Image
//                 src="/assets/svgs/apple.svg"
//                 width={118}
//                 height={94}
//                 alt="icon"
//                 className="h-fit w-full"
//             />
//             <Image
//                 src="/assets/svgs/play.svg"
//                 width={118}
//                 height={94}
//                 alt="icon"
//                 className="h-fit w-full"
//             />
//             <Image
//                 src="/assets/svgs/qr.svg"
//                 width={230}
//                 height={94}
//                 alt="icon"
//                 className=" col-span-2"
//             />
//           </span>
//         </div>
//
//         <Image
//             src="/assets/images/phoneDownload.png"
//             width={370}
//             height={470}
//             alt="app"
//             className="absolute right-0 top-0"
//         />
//     </article>;
// }

const Page = observer(() => {
  const productStore = useProductStore();

  const homepageCollections = productStore.homepageCollections;

  useEffect(() => {
    void productStore.loadHomepageCollections();
  }, [productStore]);

  return (
    <main className="flex flex-col gap-10 ">
      <PartnerSlider />
      <Categories showAll={false} />

      {homepageCollections.map((collection) => (
        <ProductsList
          key={collection.title}
          category={{
            title: collection.title,
            subTitle: collection.description,
          }}
          products={collection.results}
        />
      ))}
      <Partners
        title="Featured partner stores"
        subTitle="Shop with confidence! These trusted partners deliver exceptional service and quality products."
        partners={[]}
      />
    </main>
  );
});

export default Page;
